/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const { nodes, materials } = useGLTF('/Untitle.glb')
  return (
    <group {...props} dispose={null} position={[0, -1.5, 3.5]} rotation={[0, 4.71, 0]}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.img.geometry}
        material={materials.i}
        position={[0.124, 0.134, 0]}
        rotation={[Math.PI / 2, 0, Math.PI / 2]}
        scale={[0.224, 1, 0.212]}
      />
      <group position={[0.121, 0.007, 0]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_6001.geometry}
          material={materials['MacBookPro.001']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_8001.geometry}
          material={materials['MacBookPro.001']}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object_4001.geometry}
        material={materials['MacBookPro.001']}
      />
    </group>
  )
}

useGLTF.preload('/Untitle.glb')
